import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function AboutUs() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar forceSolid />

      <main>
        {/* Hero */}
        <section className="relative pt-20 pb-16 md:pb-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-semibold mb-6">
              <i className="ri-information-line text-sm"></i>
              Về chúng tôi
            </span>
            <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-4">
              Kết nối cơ hội — <span className="text-primary-500">Trao gửi tương lai</span>
            </h1>
            <p className="text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              Vietnam.cv ra đời với sứ mệnh đơn giản: giúp mọi người lao động Việt Nam tiếp cận cơ hội việc làm tốt hơn, 
              và giúp doanh nghiệp tìm được đúng người — <strong>hoàn toàn miễn phí</strong>.
            </p>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="py-16 md:py-20">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-background-100 rounded-2xl p-8 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl mb-5">
                  <i className="ri-focus-2-line text-primary-600 text-xl"></i>
                </div>
                <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">Sứ mệnh</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Dân chủ hóa cơ hội việc làm tại Việt Nam. Chúng tôi tin rằng mỗi người lao động đều xứng đáng có cơ hội 
                  tiếp cận thông tin tuyển dụng minh bạch, chất lượng mà không phải trả bất kỳ chi phí nào. Vietnam.cv 
                  là cầu nối giúp xóa bỏ rào cản thông tin giữa người tìm việc và nhà tuyển dụng.
                </p>
              </div>
              <div className="bg-background-100 rounded-2xl p-8 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mb-5">
                  <i className="ri-eye-line text-accent-600 text-xl"></i>
                </div>
                <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">Tầm nhìn</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Trở thành nền tảng kết nối việc làm hàng đầu Việt Nam, nơi mọi giao dịch tuyển dụng đều minh bạch, 
                  nhanh chóng và hiệu quả. Chúng tôi hướng tới một thị trường lao động công bằng, nơi tài năng được 
                  công nhận và cơ hội được chia sẻ rộng rãi.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">Giá trị cốt lõi</h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                Những nguyên tắc định hình mọi quyết định và hành động của chúng tôi
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center p-6">
                <div className="w-14 h-14 flex items-center justify-center bg-secondary-100 rounded-2xl mx-auto mb-4">
                  <i className="ri-heart-line text-secondary-600 text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-base text-foreground-950 mb-2">Miễn phí trọn đời</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  Mọi tính năng trên Vietnam.cv đều miễn phí và sẽ luôn như vậy. Không phí ẩn, không gói premium, không giới hạn.
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-14 h-14 flex items-center justify-center bg-primary-100 rounded-2xl mx-auto mb-4">
                  <i className="ri-shield-check-line text-primary-600 text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-base text-foreground-950 mb-2">Minh bạch</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  Mọi tin tuyển dụng đều được kiểm duyệt. Thông tin rõ ràng, không mập mờ về lương hay yêu cầu công việc.
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-14 h-14 flex items-center justify-center bg-accent-100 rounded-2xl mx-auto mb-4">
                  <i className="ri-user-heart-line text-accent-600 text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-base text-foreground-950 mb-2">Lấy người dùng làm trung tâm</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  Mọi tính năng được thiết kế để đơn giản, dễ dùng và thực sự hữu ích cho cả người tìm việc lẫn nhà tuyển dụng.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="py-16 md:py-20">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">Những gì chúng tôi cung cấp</h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                Một nền tảng đầy đủ cho cả người tìm việc và nhà tuyển dụng
              </p>
            </div>

            <div className="space-y-6">
              {/* For Job Seekers */}
              <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-xl">
                    <i className="ri-user-3-line text-primary-600 text-lg"></i>
                  </div>
                  <h3 className="font-heading font-bold text-lg text-foreground-950">Dành cho người tìm việc</h3>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    { icon: "ri-file-list-3-line", text: "Xem tin tuyển dụng miễn phí, không giới hạn" },
                    { icon: "ri-file-text-line", text: "Tạo CV trực tuyến chuyên nghiệp, tải PDF" },
                    { icon: "ri-send-plane-line", text: "Ứng tuyển nhanh chỉ với một click" },
                    { icon: "ri-notification-3-line", text: "Theo dõi trạng thái đơn ứng tuyển" },
                    { icon: "ri-search-line", text: "Tìm kiếm việc theo ngành nghề, địa điểm" },
                    { icon: "ri-smartphone-line", text: "Giao diện thân thiện trên mọi thiết bị" },
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-3">
                      <div className="w-8 h-8 flex items-center justify-center bg-background-50 rounded-lg flex-shrink-0 mt-0.5">
                        <i className={`${item.icon} text-foreground-500 text-sm`}></i>
                      </div>
                      <span className="text-sm text-foreground-700 leading-relaxed">{item.text}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* For Employers */}
              <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-xl">
                    <i className="ri-building-line text-accent-600 text-lg"></i>
                  </div>
                  <h3 className="font-heading font-bold text-lg text-foreground-950">Dành cho nhà tuyển dụng</h3>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    { icon: "ri-add-circle-line", text: "Đăng tin tuyển dụng miễn phí, không giới hạn" },
                    { icon: "ri-dashboard-line", text: "Dashboard quản lý tin và ứng viên" },
                    { icon: "ri-bar-chart-2-line", text: "Thống kê real-time về hiệu quả tuyển dụng" },
                    { icon: "ri-file-user-line", text: "Xem CV và thư ứng tuyển của ứng viên" },
                    { icon: "ri-check-double-line", text: "Kiểm duyệt tự động để đảm bảo chất lượng tin" },
                    { icon: "ri-download-line", text: "Xuất dữ liệu ứng viên dạng CSV" },
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-3">
                      <div className="w-8 h-8 flex items-center justify-center bg-background-50 rounded-lg flex-shrink-0 mt-0.5">
                        <i className={`${item.icon} text-foreground-500 text-sm`}></i>
                      </div>
                      <span className="text-sm text-foreground-700 leading-relaxed">{item.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Free */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="bg-accent-50 rounded-2xl p-8 md:p-10 border border-accent-200/50">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl">
                  <i className="ri-gift-line text-accent-600 text-xl"></i>
                </div>
                <h2 className="font-heading font-bold text-xl text-foreground-950">Tại sao hoàn toàn miễn phí?</h2>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Chúng tôi tin rằng cơ hội việc làm là quyền cơ bản của mỗi người lao động, không phải là hàng hóa để mua bán. 
                Bằng cách loại bỏ rào cản chi phí, chúng tôi mở rộng cánh cửa cho mọi người — từ sinh viên mới ra trường đến 
                người lao động phổ thông, từ doanh nghiệp nhỏ đến tập đoàn lớn. Vietnam.cv được vận hành bởi đội ngũ đam mê 
                công nghệ và nhân sự, với mong muốn tạo ra tác động tích cực cho thị trường lao động Việt Nam.
              </p>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 md:py-20">
          <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4">
              Sẵn sàng bắt đầu?
            </h2>
            <p className="text-sm text-foreground-500 mb-8 max-w-md mx-auto">
              Dù bạn đang tìm việc hay tìm người, Vietnam.cv luôn sẵn sàng đồng hành — hoàn toàn miễn phí.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/dang-nhap"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors no-underline cursor-pointer whitespace-nowrap"
              >
                <i className="ri-user-line text-base"></i>
                <span>Đăng ký tìm việc</span>
              </Link>
              <Link
                to="/doanh-nghiep/dang-nhap"
                className="inline-flex items-center gap-2 px-6 py-3 border border-primary-500 text-primary-600 rounded-full text-sm font-semibold hover:bg-primary-50 transition-colors no-underline cursor-pointer whitespace-nowrap"
              >
                <i className="ri-building-line text-base"></i>
                <span>Đăng ký nhà tuyển dụng</span>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}